module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tree-container"
  }, [_c('el-tree', {
    attrs: {
      "data": _vm.regions,
      "props": _vm.props,
      "load": _vm.loadNode,
      "lazy": "",
      "show-checkbox": ""
    },
    on: {
      "check-change": _vm.handleCheckChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1be7b606"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tree/tree2.vue
// module id = 121
// module chunks = 1